<template>
  <div
    ref="root"
    data-editable-wrapper
    :class="[
      !disabled ? style.editableWrapper : null,
      isActive ? style.active : ''
    ]"
    @click="openPanelByContentClick"
  >
    <PrimaryButton
      v-if="typePanel && !disabled"
      kind="icon"
      size="S"
      :icon="editIcon"
      :class="style.buttonEdit"
      @click.stop.prevent="openPanel"
    />
    <slot />
  </div>
</template>
<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./EditableWrapper.module.scss";
import editIcon from "$images/icons/button/Name=Edit, Size=16, Tone=Default.svg";
import {EditablePanelName} from "@/page/quiz/typeQuiz";
import PrimaryButton from "@/elements/UI/button/ButtonStyle/Default/primary/PrimaryButton.vue";
export default defineComponent({
  name: "EditableWrapper",
  components: {PrimaryButton},
  emits: ["openPanel"],
  props: {
    typePanel: {type: String as PropType<EditablePanelName>, default: ""},
    panelIndex: {type: Number, default: -1},
    disabled: {type: Boolean, default: false}
  },
  data() {
    return {style, editIcon};
  },

  mounted() {
    document.addEventListener("click", this.handleDocumentClick, true);
  },

  beforeUnmount() {
    document.removeEventListener("click", this.handleDocumentClick, true);
  },

  computed: {
    dataPanelClues(): {name: EditablePanelName; index: number} {
      return this.$panelStore.getDataPanelClues;
    },
    isActive(): boolean {
      return (
        this.dataPanelClues.name === this.typePanel &&
        this.dataPanelClues.index === this.panelIndex
      );
    },
    isPanelOpened(): boolean {
      return this.$panelStore.getIsShowQuestionSettingPanel;
    }
  },
  methods: {
    handleDocumentClick(event: MouseEvent): void {
      if (!this.isActive) {
        return;
      }

      const target = event.target as HTMLElement | null;
      const root = this.$refs.root as HTMLElement | undefined;

      if (!target || !root) {
        return;
      }

      if (root.contains(target)) {
        return;
      }

      if (target.closest("[data-editable-wrapper]")) {
        return;
      }

      if (target.closest("[data-setting-panel]")) {
        return;
      }

      if (target.closest("[data-floating-popup]")) {
        return;
      }

      this.$panelStore.closeSettingPanel();
    },

    openPanelByContentClick(): void {
      if (this.disabled || !this.typePanel) {
        return;
      }

      if (!this.isPanelOpened) {
        this.activateWrapper();
        return;
      }

      if (this.isActive) {
        return;
      }

      this.openPanel();
    },

    activateWrapper(): void {
      this.$panelStore.setDataPanelClues({
        name: this.typePanel,
        index: this.panelIndex
      });
    },

    openPanel(): void {
      if (this.disabled || !this.typePanel) {
        return;
      }

      this.$panelStore.openSettingPanel({
        name: this.typePanel,
        index: this.panelIndex
      });
      this.$emit("openPanel", {name: this.typePanel, index: this.panelIndex});
    }
  }
});
</script>
